import {Pipe, PipeTransform} from '@angular/core';
import {BzTagTone} from '@bringoz/ui';

/** bz-tag tone of a timecard, timecard group or analysis status. */
const STATUS_TONES: Record<string, BzTagTone> = {
  Open: 'neutral',
  Closed: 'info',
  Acknowledged: 'warning',
  Approved: 'primary',
  Completed: 'success',
  Archived: 'neutral',
  InProgress: 'info',
  PendingInput: 'warning',
  Infeasible: 'danger',
  Warning: 'warning'
};

@Pipe({
  standalone: false,
  name: 'timecardStatusTone'
})
export class TimecardStatusTonePipe implements PipeTransform {
  transform(status: string): BzTagTone {
    return STATUS_TONES[status] || 'neutral';
  }
}
